import { useEditor, useTools, useValue } from "tldraw";

export function useActiveTool() {
  const editor = useEditor();

  return useValue(
    "active tool",
    () => {
      return editor.getCurrentTool().id;
    },
    [editor],
  );
}

export function useActiveCustomTool() {
  const tools = useTools();
  const selectedId = useActiveTool();

  // Every tool of ours declares a `defaultColor` (ToolStateNode.uiToolDef);
  // tldraw's own (select, hand, draw…) do not. Keyed on that rather than on a
  // list of shape types, so a new block gets the hovering node for free.
  const tool = tools[selectedId];
  return Boolean(tool && "defaultColor" in tool) && tool;
}
